export default __webpack_public_path__ + "static/media/img8.25599100.jpg";